import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

export const selectRouting = createKeySelector('routing');

export const getCurrentPath = createSelector(selectRouting, (routing) => routing.currentPath);

export const getPreviousPath = createSelector(selectRouting, (routing) => routing.prevPath);

export const getPathName = createSelector(selectRouting, (routing) => routing.pathname);

export const getUrlSearch = createSelector(selectRouting, (routing) => routing.search);

export const getRouteParams = createSelector(selectRouting, (routing): any => routing.params);

export const getNavigateDuration = createSelector(
  selectRouting,
  (routing) => routing.navigateDuration
);

export const getNavigateStart = createSelector(selectRouting, (routing) => routing.navigateStart);

export const getNavigateInfo = createSelector(selectRouting, (routing) => routing.navigate);
